import qs from 'query-string'
import { useQueryClient } from 'react-query'

import { useMutationApi, useQueryApi } from 'utils/api'

import type {
  RequestDeleteKinerjaHarian,
  RequestGetKinerjaHarianActive,
  RequestGetKinerjaHarianContents,
  RequestGetKinerjaHarianLogs,
  RequestUpsertKinerjaHarian,
  ResponseDeleteKinerjaHarian,
  ResponseGetKinerjaHarianActive,
  ResponseGetKinerjaHarianContent,
  ResponseGetKinerjaHarianLogs,
} from 'types/kinerja-harian'
import type { CustomError } from 'types/custom-error'

const basePath = '/guru/skp/v1/kinerja-harian'

export const API_GET_KINERJA_HARIAN_LOGS_QUERY_KEY =
  'API_GET_KINERJA_HARIAN_LOGS_QUERY_KEY'

export function useAPIGetKinerjaHarianActive({
  params,
  options,
}: RequestGetKinerjaHarianActive) {
  const path = `${basePath}/active`
  const rawParams = {
    skpYear: params?.skpYear,
    skpPeriod: params?.skpPeriod,
    ...(params.tipe && { tipe: params.tipe }),
  }

  return useQueryApi<ResponseGetKinerjaHarianActive>(path, {
    queryConfig: {
      ...options,
    },
    axiosConfig: {
      params: rawParams,
    },
    queryKey: [path, rawParams],
  })
}

export function useAPIGetKinerjaHarianLogs({
  params,
  options,
}: RequestGetKinerjaHarianLogs) {
  const path = basePath
  const rawParams = {
    start_date: params.startDate,
    end_date: params.endDate,
  }

  return useQueryApi<ResponseGetKinerjaHarianLogs>(path, {
    axiosConfig: {
      params: rawParams,
    },
    queryConfig: {
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 60 * 60 * 1000, // 1 hour
      ...options,
    },
    queryKey: [API_GET_KINERJA_HARIAN_LOGS_QUERY_KEY, rawParams],
  })
}

const API_GET_KINERJA_HARIAN_CONTENTS_QUERY_KEY =
  'API_GET_KINERJA_HARIAN_CONTENTS_QUERY_KEY'
export function useAPIGetKinerjaHarianContents({
  params,
  options,
}: RequestGetKinerjaHarianContents) {
  const path = `/guru/skp/v1/konten/harian`

  return useQueryApi<ResponseGetKinerjaHarianContent>(path, {
    axiosConfig: {
      params: {
        role: params.role,
        tipe: params.tipe,
        requested_date: params.requestedDate,
      },
    },
    queryConfig: options,
    queryKey: [API_GET_KINERJA_HARIAN_CONTENTS_QUERY_KEY, params],
  })
}

export function useAPIPostUpsertKinerjaHarian() {
  return useMutationApi<any, any, RequestUpsertKinerjaHarian>(basePath, {
    axiosConfig: { method: 'POST' },
  })
}

export function useAPIDeleteKinerjaHarian() {
  const queryClient = useQueryClient()

  return useMutationApi<
    ResponseDeleteKinerjaHarian,
    CustomError,
    RequestDeleteKinerjaHarian
  >((data: RequestDeleteKinerjaHarian) => `${basePath}?${qs.stringify(data)}`, {
    axiosConfig: { method: 'DELETE' },
    mutationConfig: {
      onSuccess: () => {
        queryClient.invalidateQueries(API_GET_KINERJA_HARIAN_LOGS_QUERY_KEY)
      },
    },
  })
}
